import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiStaffDetailGet } from '@/entities/staff/modules/api/staff';

export const useStaffDetail = (id: string) =>
  useFetch({
    api: () => apiStaffDetailGet(id),
    keywords: queryKeys.staff.detail(id),
    enabled: Boolean(id),
    staleTime: 60_000,
  });
